<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12" md="6">
                <b-row>
                    <b-col cols="12">
                        <h3 class="text-primary text-uppercase">Dati Società</h3>
                    </b-col>
                </b-row>
                <b-row class="align-items-end">
                    <b-col cols="10" md="10" class="mb-3">
                        <inter-input
                                label="Nome"
                                v-model="user.data.society"
                                icon="group"
                                :error="errors.society">
                        </inter-input>
                    </b-col>
                    <b-col cols="2" md="2" class="ml-auto mb-3 ">
                        <swatches v-model="user.color"
                                  colors="text-advanced"
                                  popover-to="left"
                                  :trigger-style="{ width: '50px', height: '50px' }"
                        >
                        </swatches>
                    </b-col>
                </b-row>
                <b-row class="align-items-end">
                    <b-col cols="12" md="7" class="mb-3">
                        <inter-input
                                label="Email"
                                v-model="user.data.society_email"
                                icon="mail"
                                :error="errors.society_email">
                        </inter-input>
                    </b-col>
                    <b-col cols="12" md="5" class="mb-3">
                        <inter-input
                                label="Telefono"
                                v-model="user.data.society_phone"
                                icon="phone-call"
                                :error="errors.society_phone">
                        </inter-input>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12" md="6">
                <b-row>
                    <b-col cols="12">
                        <h3 class="text-primary text-uppercase">Dati Referente</h3>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12" md="6" class="mb-3">
                        <inter-input
                                label="Nome"
                                v-model="user.name"
                                icon="group"
                                :error="errors.name">
                        </inter-input>
                    </b-col>
                    <b-col cols="12" md="6" class="mb-3">
                        <inter-input
                                label="Cognome"
                                v-model="user.surname"
                                icon="group"
                                :error="errors.surname">
                        </inter-input>
                    </b-col>
                </b-row>
                <b-row class="align-items-end">
                    <b-col cols="12" md="7" class="mb-3">
                        <inter-input
                                label="Email"
                                v-model="user.email"
                                icon="mail"
                                :error="errors.email">
                        </inter-input>
                    </b-col>
                    <b-col cols="12" md="5" class="mb-3">
                        <inter-input
                                label="Telefono"
                                v-model="user.data.phone"
                                icon="phone-call"
                                :error="errors.phone">
                        </inter-input>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

    </b-container>
</template>

<script>
    import InterInput from "../../../components/form/inter-input/InterInput";
    import User from "@/models/User";
    import Swatches from "vue-swatches/src/Swatches";
    import _ from "lodash";

    export default {
        name: "SocietyForm",
        components: {Swatches, InterInput},
        data() {
            return {
                errors: {}
            }
        },
        props: {
            user: {
                type: Object,
                default: () => Object.assign({}, User)
            },
        },
        methods: {
            validate: function () {
                this.errors = {};
                if (this.user.name === '') {
                    this.errors.name = true;
                }
                if (this.user.surname === '') {
                    this.errors.surname = true;
                }

                if (this.user.email === '') {
                    this.errors.email = true;
                }

                if (_.isEmpty(this.errors)) {
                    return true;
                } else {
                    this.$bvToast.toast('Mi manca qualche dato', {
                        title: 'Alert',
                        variant: 'warning'
                    });
                    return false;
                }
            }
        }
    }
</script>

<style scoped>

</style>
